import React, { useContext } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { UserContext } from "../GlobalContexts/UserContext.js";
// import { Auth } from "aws-amplify";

export default function AuthenticatedRoute({ children, ...rest }) {
  const { pathname, search } = useLocation();
  const { user } = useContext(UserContext);

  return (
    <Route {...rest}>
      {
        // user !== null ? (
        user !== null && user.isAuthenticated ? (
          children
        ) : (
          <Redirect to={`/login?redirect=${pathname}${search}`} />
        )
        // ) : null
        // <Redirect to={`/login?redirect=${pathname}${search}`} />
      }
    </Route>
  );
}
